// extracted by mini-css-extract-plugin
export default {"container":"style_container__sLZ8A","innerBox":"style_innerBox__dYSr3"};